// extracted by mini-css-extract-plugin
export default {"cartIcon":"CartIcon_cartIcon__EYbMe","cartIconBadge":"CartIcon_cartIconBadge__VLo6p"};